import React, { useState } from 'react';
interface Props {
  closePop: Function;
  source: string;
}
const SurveyResultPopup = ({ closePop, source }: Props) => {
  if (!source) {
    return <div className="modal-content">Loading...</div>;
  }
  return (
    <div className="modal-content">
      <a
        href="javascript:void(0)"
        className="modal-close"
        onClick={() => closePop(false)}
      ></a>
      <iframe id="surveyIframe" src={source} />
    </div>
  );
};
export default SurveyResultPopup;